import PropTypes from 'prop-types';
import styled from 'styled-components';

import { connect } from 'react-redux';

const StyledList = styled.ul`
  position: relative;
  background: #fff;
  clear: both;
  max-height: 40px;
  margin: 0;
  white-space: nowrap;
  font-size: 0;
  text-align: center;
  
  @media ${({ theme }) => theme.breakpoints.touch} {
    display: none;
  }
`;

const StyledListItem = styled.li`
  display: inline-block;
  width: 25%;
  margin: 0;
  vertical-align: top;
  font-size: 13px;
`;

const StyledLink = styled.a`
  display: block;
  color: #161b7a;
  padding: 0;
  line-height: 40px;
  font-weight: normal;
  text-align: center;
`;

const LinksAboveBreadcrumb = ({ links }) => (
  links
    ? (
      <StyledList className={'features'}>
        {links.map((link) => (
          <StyledListItem key={link.url + link.imgSrc}>
            <StyledLink href={link.url}>
              <img src={link.imgSrc} alt={''} />
            </StyledLink>
          </StyledListItem>
        ))}
      </StyledList>
    ) : null
);

LinksAboveBreadcrumb.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      imgSrc: PropTypes.string.isRequired
    }).isRequired
  )
};

LinksAboveBreadcrumb.defaultProps = {
  links: undefined
};

const mapStateToProps = (state) => ({
  links: state?.listingPage?.staticData?.linksAboveBreadcrumb
});

export default connect(mapStateToProps)(LinksAboveBreadcrumb);
